import get from "lodash/get"

// Matching legacy {{ }} style variables and newer @ style variables.
const re =
  /({{ *(?<bracketVariable>[a-zA-Z._]+) *}}|@(?<atVariable>([a-zA-Z_-]|\.(?=[a-zA-Z_-]+))+))/g

export const interpolateVariables = (text, templateContext) => {
  const replaceFn = (fullStr, matchedStr, ...args) => {
    // Get matching groups, which is last arg suppled to replaceAll function.
    const groups = args.slice(-1)[0]
    // Get the matched group.
    const variable = Object.values(groups).find(Boolean)
    // Get the value from the templateContext using the variable path.
    // If the variable path yields undefined, default to matched string (likely not a variable after all).
    const value = get(templateContext, variable, matchedStr)
    return value
  }

  return text.replace(re, replaceFn)
}
